export default __webpack_public_path__ + "static/media/presentation.fccfeee7.png";